import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPlannedCheckItemsForTask, putPlannedCheckItemsForTask } from "../../store/actions/PMActions";
import * as queryString from "query-string";
import TaskCheckList from "../../components/CheckItemGroup/TaskCheckList";
import { getPlannedCheckItemFiles } from "../../store/actions/CheckItemGroupActions";

export default function PlannedTaskCheckList() {
    const dispatch = useDispatch();
    const [pageLoaded, setPageLoaded] = useState(true);
    let [rows, setRows] = useState([]);
    // File Management
    const [checkItemFiles, setCheckItemFiles] = useState([]);
    const [isDocumentPopupOpen, setIsDocumentPopupOpen] = useState(false);

    // Create use effect for load handler
    const taskId = queryString.parse(window.location.search).id;
    useEffect(() => {
        dispatch(getPlannedCheckItemsForTask(taskId));
    }, []);

    const { plannedCheckItemsForTask } = useSelector(({ pm }) => pm);
    const { plannedCheckItemFiles } = useSelector(({ CheckItemGroup }) => CheckItemGroup);

    useEffect(() => {
        if (plannedCheckItemsForTask?.resultObject?.content) {
            var incomingRows = Object.values(plannedCheckItemsForTask.resultObject.content);
            incomingRows.forEach((row) => {
                var groupStatu = true;
                row.taskCheckItems.map((item) => {
                    if (item.comment === null) item.comment = "";
                    if (item.comment === "" && item.checked === false) {
                        groupStatu = false;
                    }
                });
                row["statu"] = groupStatu;
            });
            setPageLoaded(true);
            setRows(Object.values(plannedCheckItemsForTask.resultObject.content));
        }
    }, [plannedCheckItemsForTask]);

    useEffect(() => {
        if (plannedCheckItemFiles) {
            setCheckItemFiles(plannedCheckItemFiles);
        }
    }, [plannedCheckItemFiles]);

    const setRowsFunction = (newRows) => {
        setRows(newRows);
    };

    // Handle Save Action
    const handleSave = () => {
        let data = [];
        rows.forEach((row) => {
            row.taskCheckItems.map((item) => {
                data.push({
                    checkItemId: item.checkItemId,
                    checked: item.checked,
                    comment: item.comment,
                });
            });
        });
        var payload = {
            taskId: taskId,
            data: data,
        };
        dispatch(putPlannedCheckItemsForTask(payload));
    };

    const HandleDocumentPopupOpen = (id) => {
        setIsDocumentPopupOpen(true);
        dispatch(getPlannedCheckItemFiles(id));
    };

    return (
        <TaskCheckList
            rows={rows}
            pageLoaded={pageLoaded}
            handleSave={handleSave}
            setRowsFunction={setRowsFunction}
            HandleDocumentPopupOpen={HandleDocumentPopupOpen}
            isDocumentPopupOpen={isDocumentPopupOpen}
            setIsDocumentPopupOpen={setIsDocumentPopupOpen}
            checkItemFiles={checkItemFiles}
        ></TaskCheckList>
    );
}
